import { safeSessionStorage } from '@repo/dom/storage';
import { GraphQLClient } from 'graphql-request';
import { env } from '../utils/env';
import { getRetailerFromUrl } from '../utils/getRetailerFromUrl';
import { STORAGE_KEYS } from '../utils/constants';
import {
  ensureFingerprintReady,
  getFingerprintHeaders,
} from '../utils/fingerprint';

const searchParams = new URLSearchParams(window.location.search);
const retailer = getRetailerFromUrl();
if (retailer) {
  searchParams.set('retailer', retailer);
}

export const buildGraphQLHeaders = (): Record<string, string> => {
  const token = safeSessionStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  const fingerprintHeaders = getFingerprintHeaders();

  return {
    ...(token ? { 'X-Authentication': token } : {}),
    ...fingerprintHeaders,
  };
};

export const createGraphQLClient = (): GraphQLClient => {
  const retailer = getRetailerFromUrl();
  const searchParams = new URLSearchParams(
    typeof window !== 'undefined' ? window.location.search : '',
  );

  if (retailer) {
    searchParams.set('retailer', retailer);
  }

  const url = `${env.VITE_PDP_GRAPHQL_URL}?${searchParams.toString()}`;

  return new GraphQLClient(url, {
    headers: buildGraphQLHeaders,
  });
};

// Wait for fingerprint to be ready before creating the client
let clientPromise: Promise<GraphQLClient> | null = null;

const getClient = async (): Promise<GraphQLClient> => {
  if (!clientPromise) {
    clientPromise = ensureFingerprintReady().then(() => createGraphQLClient());
  }
  return clientPromise;
};

export const client = await getClient();
